import {
  Textsms,
  Bookmark,
  Place,
  Restaurant,
  BookmarkBorderOutlined,
  WhereToVoteOutlined,
  IosShareOutlined,
} from "@mui/icons-material";
import { Box, Rating, Typography } from "@mui/material";
import { IStoreDetailData } from "features/searchStore/models";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useAppSelector } from "redux/hooks";

export const StoreInfoSection = () => {
  const storeData = useAppSelector(selectStoreDetail);
  return (
    <Box
      width="100%"
      display="flex"
      boxShadow={1}
      borderTop={1}
      justifyContent="center"
    >
      <Box display="flex" flexDirection="column" p={1} width="1000px">
        <Box display="flex">
          <Typography
            variant="h4"
            sx={{ display: "flex", flex: 1, alignItems: "center" }}
          >
            {storeData.Name}
          </Typography>
          <Box display="flex">
            <Box
              p={2}
              sx={{
                cursor: "pointer",
                transition: "color 0.3s ease-in-out",
                "&:hover": {
                  color: "primary.main",
                },
              }}
            >
              <IosShareOutlined />
            </Box>

            <Box
              p={2}
              sx={{
                cursor: "pointer",
                transition: "color 0.3s ease-in-out",
                "&:hover": {
                  color: "primary.main",
                },
              }}
            >
              <BookmarkBorderOutlined />
            </Box>
          </Box>
        </Box>

        <Box display="flex" alignItems="center" my={1}>
          <Box display="flex" alignItems="center">
            <Place color="primary" />
            <Typography sx={{ mx: 1 }}>{storeData.Area}</Typography>
          </Box>
          <Box display="flex" alignItems="center" mx={2}>
            <Restaurant color="primary" />
            <Typography sx={{ mx: 1 }}>{storeData.Genres.join("/")}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
